import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const SCORE_CARD_CALCULATE = createAsyncActionType(
  "SCORE_CARD_CALCULATE"
);

export const SCORE_CARD_CALCULATE_CLEAR = "SCORE_CARD_CALCULATE_CLEAR";



// WEBPACK FOOTER //
// ./src/features/score-card/types/scoreCardCalculate.js